const firebaseConfig = {
  apiKey: "AIzaSyBIfQe7FPmqG8cg8cLSM9OB2WFlYbiX7sw",
  authDomain: "cryptoo-45c69.firebaseapp.com",
  projectId: "cryptoo-45c69",
  storageBucket: "cryptoo-45c69.appspot.com",
  messagingSenderId: "871041804806",
  appId: "1:871041804806:web:aacc18eb9b568e96eab187",
  measurementId: "G-CHVP7YLWTS",
};

export default firebaseConfig;
